import PropTypes from 'prop-types'
import React from 'react'

// Components
import { NoteEditor } from '../NoteEditor/NoteEditor'
import { NoteList } from '../NoteList/NoteList'
import { S_NoteListWrapper } from './NoteListEditor.styles'

export const NoteListEditor = ({
  allowEdit = false,
  allowRemove = false,
  allowPin = false,
  error = '',
  flexType = 'row',
  isSaving = false,
  listLabel = '',
  newNoteValue = '',
  noteStyle = '',
  notes = [],
  notesLabel = '',
  onChange = () => {},
  onRemoveNote = () => {},
  onSave = () => {},
  onUpdateNote = () => {},
  onPinNote = () => {},
}) => {
  return (
    <S_NoteListWrapper>
      <NoteEditor
        error={error}
        flexType={flexType}
        isSaving={isSaving}
        label={notesLabel}
        noteStyle={noteStyle}
        onChange={onChange}
        onSave={onSave}
        value={newNoteValue}
      />
      <NoteList
        allowEdit={allowEdit}
        allowPin={allowPin}
        allowRemove={allowRemove}
        label={listLabel}
        noteStyle={noteStyle}
        notes={notes}
        onPinNote={onPinNote}
        onRemoveNote={onRemoveNote}
        onUpdateNote={onUpdateNote}
      />
    </S_NoteListWrapper>
  )
}

NoteListEditor.propTypes = {
  allowEdit: PropTypes.bool,
  allowRemove: PropTypes.bool,
  allowPin: PropTypes.bool,
  error: PropTypes.string,
  flexType: PropTypes.string,
  isSaving: PropTypes.bool,
  listLabel: PropTypes.string,
  newNoteValue: PropTypes.string,
  noteStyle: PropTypes.string,
  notes: PropTypes.array,
  notesLabel: PropTypes.string,
  onChange: PropTypes.func,
  onRemoveNote: PropTypes.func,
  onSave: PropTypes.func,
  onUpdateNote: PropTypes.func,
  onPinNote: PropTypes.func,
}
